<template>
  <div
    class="w-full py-[calc((100vh-500px)/2)] max-xl:py-[max(calc((100vh-750px)/2), 48px)] max-md:py-[calc((100vh-550px)/2)] overflow-scroll h-[100vh] max-md:!h-[90vh]"
  >
    <div
      class="mx-auto mb-[110px] max-md:mb-[48px] leading-[110%] tracking-normal max-md:max-w-[400px] max-w-[1100px] text-center flex items-center justify-center text-[60px] max-md:text-[30px] font-medium text-[#000000]"
    >
      {{
        globleConfig.appname == "Mureka"
          ? "The most powerful API platform for creating AI music"
          : "Mureka 开放平台"
      }}
    </div>
    <div
      class="text-[22px] max-md:text-[16px] text-center text-[#000000] mb-[36px]"
    >
      {{
        globleConfig.appname == "Mureka"
          ? "Access the power of our models with APIs"
          : "稳定生成，音质出众"
      }}
    </div>
    <div
      class="flex mx-auto max-xl:max-w-[500px] max-md:max-w-[320px] flex-wrap items-center justify-center gap-[32px]"
    >
      <div
        v-for="item in FuncList"
        :key="item.name"
        class="flex hover:scale-110 transition-all cursor-pointer flex-col max-md:gap-[8px] max-md:w-[80px] gap-[24px] items-center justify-center"
        @click="goTo(item.path)"
      >
        <div
          class="flex items-center justify-center w-[140px] h-[140px] max-md:w-[70px] max-md:h-[70px] rounded-full bg-[rgba(0,0,0,0.05)]"
        >
          <SvgIcon
            class="w-[40px] h-[40px] max-md:w-[28px] max-md:h-[28px]"
            :name="item.img"
          />
        </div>
        <div class="text-[#000000] max-md:text-[12px] text-[14px] text-center">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import globleConfig from "@/config/config.js";
import { isDev } from "@/utils/tools.js";
import {  $$t } from "@/i18n/i18n.js";

const FuncList = [
  {
    img: "music_1",
    name: $$t("overview.music_generation"),
    path: "api/operations/post-v1-song-generate.html",
  },
  {
    img: "music_2",
    name: $$t("overview.custom_music_model"),
    path: "api/operations/post-v1-finetuning-create.html",
  },
  {
    img: "music_3",
    name: $$t("overview.custom_vocal_tone"),
    path: "api/operations/post-v1-song-generate.html",
  },
  {
    img: "music_4",
    name: $$t("overview.utilize_reference_Track"),
    path: "api/operations/post-v1-song-generate.html",
  },
  {
    img: "music_5",
    name: $$t("overview.ai_lyric_writing"),
    path: "api/operations/post-v1-lyrics-generate.html",
  },
  {
    img: "music_6",
    name: $$t("overview.text_to_speech"),
    path: "api/operations/post-v1-tts-generate.html",
  },
];

const goTo = (path: string) => {
  // router.push(path);
  const url = `https://${
    isDev() ? "platform-test" : "platform"
  }.mureka.ai/docs/`;
  window.open(url + path, "_blank");
};
</script>

<style scoped>
h1 {
  font-size: 2em;
  margin-bottom: 1em;
}

button {
  font-size: 1em;
  padding: 0.5em 1em;
  color: white;
  background-color: #42b983;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #2c8e5e;
}
</style>
